import sampleMockupData from './mock/sampleData01.json'
import companySampleData from './mock/companySampleData.json'
import sampleMockupData2 from './mock/sampleData02.json'
import { isUseAPI } from '@/utils/check'
import request from '@/utils/request'
import axios from 'axios'

export function getSample01() {
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(sampleMockupData)
  })
}

export function getSample02() {
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(sampleMockupData2)
  })
}

// 회사 조회하는 sample API
export function getCompanySample() {
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(companySampleData)
  })
}

// 저장 sample API
export function saveSample01(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/sample',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var updatedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/sample',
        method: 'put',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/sample',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // updated 에 담긴 데이터가 있으면, request put 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
      saveActions.push(updatedAction(gridSaveDatas.updated))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 response를 던져준다.
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}
